var Vector3DUtils = (function () {
    function Vector3DUtils() {
    }
    return Vector3DUtils;
}());
export { Vector3DUtils };
